module.exports = __webpack_public_path__ + "friends.155aec6e.png";